<template>
  <v-app dark>
    <v-toolbar
      color="deep-purple"
      app
      :clipped-left="clipped"
    >   

       <router-link to="/"><img style="transform: translateY(10px)" src="static/img/flat-icons/purple-hat.svg" alt="John" height="72px"></router-link>          
       <router-link to="/"><v-toolbar-title class="ml-2" style="">Progressive Web Novel <span class="body-2 ml-1" style="opacity:0.75; letter-spacing: 1.2px;">ALPHA</span></v-toolbar-title>   </router-link>   
            
             
       
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="mr-2">
        <v-icon>menu</v-icon>
      </v-btn>
    </v-toolbar>
    <vue-progress-bar></vue-progress-bar>
    <v-content>      
      <router-view/>   
    </v-content>
    <v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
      app
      width="600"
    >
      <v-list dense>
      <v-container
        fluid
        style="min-height: 0;"
        grid-list-lg
        
      >
        <v-layout row wrap>         
          <v-flex xs12>            
            <v-card hover flat color="blue-grey darken-2" class="white--text" router to="/the-lab">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs4>
                    <v-card-media
                      src="static/img/flat-icons/sword-line.svg"
                      height="125px"
                      contain
                    ></v-card-media>
                  </v-flex>
                  <v-flex xs8>
                    <div>
                      <div class="headline">e-litRPG</div>
                      <div>It's a RPG, a game! Yet it's a literature!<br /><br />The next generation of <i>Choose-Your-Own-Adventure</i> stories... it's super fun!</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>        
          <v-flex xs12>            
            <v-card flat hover color="pink darken-1" class="white--text" to="/dynamic-stories">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="headline">Dynamic Stories</div>
                      <div>Whether it's non-linear novel with multiple endings, or code-based generated story elements, these novels will ensure your reading experience fresh and magical.</div>
                    </div>
                  </v-flex>
                  <v-flex xs5>
                    <v-card-media
                      src="static/img/flat-icons/unicorn-line.svg"
                      height="125px"
                      contain
                    ></v-card-media>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs12>            
            <v-card flat hover color="green accent-4" class="white--text" router to="/the-lab">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs4>
                    <v-card-media
                      src="static/img/flat-icons/green-potion-line.svg"
                      height="125px"
                      contain                      
                    ></v-card-media>
                  </v-flex>
                  <v-flex xs8>
                    <div>
                      <div class="headline">The Lab</div>
                      <div>Join us in the journey of uncovering the real potentials of web novels, experimenting literature with the ever evolving nature of world wide web.</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>           
          </v-flex>
          <v-subheader>Want to contribute?</v-subheader>
          <v-flex xs12>
            <v-card flat hover color="orange darken-1" class="white--text" router to="/the-lab">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="headline">Support us on Patreon</div>
                      <div>Supports from you give us very warm welcome and motivations to create more awesome things!</div>
                    </div>
                  </v-flex>
                  <v-flex xs5>
                    <v-card-media
                      src="static/img/flat-icons/cookies-line.svg"
                      height="125px"
                      contain
                    ></v-card-media>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card flat color="grey darken-1" class="white--text">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs5>
                    <v-card-media
                      src="static/img/flat-icons/desktop-pencil-line.svg"
                      height="125px"
                      contain
                    ></v-card-media>
                  </v-flex>
                  <v-flex xs7>
                    <div>
                      <div class="headline">Join Us! (closed)</div>
                      <div>While we're not looking for new team members during ALPHA phase, maybe in the future it will be different. Who knows?</div>
                    </div>
                  </v-flex>                  
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      </v-list>
    </v-navigation-drawer>
    <v-footer
      dark
      height="auto"
    >
      <v-card
        flat
        tile
        class="deep-purple white--text text-xs-center"
      >
        <v-btn color="info" class="donate" href="https://www.paypal.me/sidekaraktergendut" target="_blank"><i class="fab fa-paypal"></i> DONATE WITH PAYPAL</v-btn>

        <v-card-text class="white--text pt-0">
          Donations for project funding are welcomed for me to buy a decent machine for web development, plus an HTTPS website
          hosting in the future.<br/><br/>
          <div class="credit">Icons made by <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="white--text">
          &copy;2018 — <strong>SideKarakterGendut</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Progressive Web Novel'
    }
  },
  name: 'App'
}
</script>

<style scoped>
  @import url('https://use.fontawesome.com/releases/v5.2.0/css/all.css');
  .fab.fa-paypal{
    font-size: 18px;
    margin-right: 8px;
  }
  a {
    text-decoration: none;
    color: #fffe;
  }
  .navigation-drawer{
    padding-bottom: 35px;
  }
  .donate{
    margin-top: 2em;
    margin-bottom: 1.25em;    
  }
  .v-card{
    width: 100%;
  }
  .v-card__text{
    padding: 10px 30%;
    font-family: 'Quicksand', sans-serif;
  }
  .credit{
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-style: italic;
    font-size: 12.875px;
  }
  .credit a{
    font-weight: 600;
    color:#D1C4E9;
    transition: all 0.1s ease-in;
    text-decoration: none;
    border-bottom: #D1C4E9 1px solid;
    padding: 0 5px;    
    font-style: normal;
    padding-top: 4px;
  }
  .credit a:hover{
    background: #D1C4E9;
    color: rgb(145, 104, 218);    
  }
</style>
 


// WEBPACK FOOTER //
// src/App.vue